import { useEffect, useState } from "react";
import { PageLoader } from "../../../components/loader/pageLoader";
import { IncomeFormulaItem } from "../../../components/incomeFormulaItem/incomeFormulaItem";
import { cafeButtons } from "./cafeButtons";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { ArrowIcon, DownloadIcon, InfoIcon } from "../../../assets/icons";
import { ProfileInfo } from "../../../components/profileInfo/profileInfo";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { usePopup } from "../../../components/popup/popup";
import { Text } from "../../../components/text/text";
import AdminAPI from "../../../api/AdminAPI";
import IncomeAPI from "../../../api/IncomeAPI";

import styles from "./cafeInfo.module.css";
import { NumberInput } from "../../../components/numberInput/numberInput";


export const AdminCafeInfo = () => {
    const openPage = useOpenPage();

    const { cafeId } = useParams();
    const [loading, setLoading] = useState(0);

    const [cafeInfo, setCafeInfo] = useState({
        name: `Предприятие ${cafeId}`,
        address: `Адрес предприятия ${cafeId}`
    });
    useEffect(() => {
        if (!cafeId) return;
        AdminAPI
            .fetchCafeInfo(cafeId)
            .then(setCafeInfo)
            .catch(console.error)
            .finally(setLoading(prev => prev + 1));
    }, [cafeId]);

    const [averageDaily, setAverageDaily] = useState(0);
    useEffect(() => {
        if (!cafeId) return;
        IncomeAPI
            .fetchAdminAverageDaily(cafeId)
            .then(setAverageDaily)
            .catch(console.error)
            .finally(() => setLoading(prev => prev + 1));
    }, [cafeId]);

    const userName = useSelector(state => state.user?.name);
    const userPhoto = useSelector(state => state.user?.profilePhotoUrl);

    const adminInfo = {
        name: userName || "Администратор",
        photo: userPhoto,
    }

    const [monthlyLoading, setMonthlyLoading] = useState(false);
    const downloadReport = (date) => {
        setMonthlyLoading(true);
        AdminAPI
            .downloadMonthlyReport({ ...date, cafeId })
            .catch(console.error)
            .finally(setMonthlyLoading(false))
    }

    const [reportMonth, setReportMonth] = useState(new Date().getMonth() + 1);
    const [reportYear, setReportYear] = useState(new Date().getFullYear());
    const [Popup, open, close] = usePopup();
    const handleDownloadReport = () => {
        close();
        downloadReport({ month: +reportMonth, year: +reportYear });
    }

    const handleOpen = () => {
        open();
        setReportMonth(new Date().getMonth() + 1);
        setReportYear(new Date().getFullYear());
    }

    if (loading < 2) {
        return <PageLoader />
    }

    return (
        <>
            <div className={styles.cafe_info}>
                <Text as="div" variant="h1" className={styles.cafe_name} >{cafeInfo.name}</Text>
                <Text as="div" variant="body" className={styles.cafe_address} >{cafeInfo.address}</Text>
            </div>

            <div className={styles.title_container}>
                <Text as="div" variant="bodyStrong" className={styles.title} >Выручка</Text>
                <div className={styles.income_stats}>
                    <IncomeFormulaItem title="День" value={averageDaily} />
                    <IncomeFormulaItem title="Неделя" value={averageDaily * 7} />
                    <IncomeFormulaItem title="Месяц" value={averageDaily * 30} />
                </div>
            </div>

            <div className={styles.title_container}>
                <Text as="div" variant="bodyStrong" className={styles.title} >Админ</Text>
                {
                    !!adminInfo &&
                    <Button
                        text={<ProfileInfo photo={adminInfo.photo} name={adminInfo.name} />}
                        type="secondary"
                        icon={<InfoIcon width="20px" height="20px" />}
                        onClick={openPage(`/admin/${cafeId}/profile`)}
                    />
                }
            </div>

            <div className={styles.title_container}>
                <Text as="div" variant="bodyStrong" className={styles.title} >Действия</Text>
                <div className={styles.cafe_buttons}>
                    {
                        cafeButtons.map(data => (
                            <Button
                                key={data.id}
                                text={data.text}
                                onClick={openPage(data.path)}
                                icon={<ArrowIcon />}
                                type="secondary"
                            />
                        ))
                    }
                </div>
            </div>

            <Button
                text="Получить отчет за месяц"
                type="info"
                disabled={monthlyLoading}
                onClick={handleOpen}
                icon={<DownloadIcon width="20px" height="20px" />}
            />

            <Popup>
                <Text as="div" variant="h2" className={styles.popup_title} >Отчет за месяц</Text>

                <div className={styles.row}>
                    <NumberInput
                        withoutTransform
                        label="Месяц"
                        val={reportMonth}
                        setVal={(value) => setReportMonth(value)}
                        error={reportMonth < 1 || reportMonth > 12}
                        />
                    <NumberInput
                        withoutTransform
                        label="Год"
                        val={reportYear}
                        setVal={(value) => setReportYear(value)}
                        error={reportYear < 1000 || reportYear > 9999}
                    />
                </div>

                <div className={styles.row}>
                    <Button
                        text="Отмена"
                        onClick={close}
                        type="hint"
                    />

                    <Button
                        text="Скачать"
                        onClick={handleDownloadReport}
                        disabled={monthlyLoading || reportMonth < 1 || reportMonth > 12 || reportYear < 1000 || reportYear > 9999}
                    />
                </div>
            </Popup>
        </>
    );
} 